// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OrganisationOther-module__inputBox___1pBs8{border-radius:4px;border:solid 1px #494d56;padding:10px;margin-bottom:5px;width:100%}.OrganisationOther-module__title___211Ye{font-weight:bold}.OrganisationOther-module__section___YMCaX{margin-top:20px}.OrganisationOther-module__note___2WY1H{margin-top:10px}.OrganisationOther-module__error___3tAxR{margin-top:-15px}", ""]);
// Exports
exports.locals = {
	"inputBox": "OrganisationOther-module__inputBox___1pBs8",
	"title": "OrganisationOther-module__title___211Ye",
	"section": "OrganisationOther-module__section___YMCaX",
	"note": "OrganisationOther-module__note___2WY1H",
	"error": "OrganisationOther-module__error___3tAxR"
};
module.exports = exports;
